<!-- == Unichat Extension ==
Popup no canto inferior esquerdo, exibido quando uma conversa é
encaminhada para um Setor do qual o agente logado é membro. Some
automaticamente depois de 3 segundos. -->
<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { emitter } from 'shared/helpers/mitt';

const visible = ref(false);
const teamName = ref('');
const senderName = ref('');
const conversationId = ref(null);
let hideTimer = null;

const onTeamNotification = data => {
  const team = data?.primary_actor?.meta?.team;
  if (!team) return;

  teamName.value = team.name;
  senderName.value = data?.primary_actor?.meta?.sender?.name || 'Cidadão';
  conversationId.value = data?.primary_actor?.id;
  visible.value = true;

  clearTimeout(hideTimer);
  hideTimer = setTimeout(() => {
    visible.value = false;
  }, 3000);
};

onMounted(() => {
  emitter.on('UNICHAT_TEAM_NOTIFICATION', onTeamNotification);
});

onBeforeUnmount(() => {
  emitter.off('UNICHAT_TEAM_NOTIFICATION', onTeamNotification);
  clearTimeout(hideTimer);
});
</script>

<template>
  <Transition name="unichat-team-toast-fade">
    <div v-if="visible" class="unichat-team-toast">
      <div class="unichat-team-toast__icon">
        <i class="i-lucide-bell-ring size-4" />
      </div>
      <div class="unichat-team-toast__body">
        <p class="unichat-team-toast__title">Nova conversa · {{ teamName }}</p>
        <p class="unichat-team-toast__subtitle">
          {{ senderName }} · #{{ conversationId }}
        </p>
      </div>
    </div>
  </Transition>
</template>

<style scoped>
.unichat-team-toast {
  position: fixed;
  left: 16px;
  bottom: 16px;
  z-index: 9999;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  border-radius: 12px;
  background: #1a1d22;
  border: 1px solid rgba(34, 197, 94, 0.25);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);
  max-width: 320px;
}

.unichat-team-toast__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: rgba(34, 197, 94, 0.16);
  color: #22c55e;
  flex-shrink: 0;
}

.unichat-team-toast__title {
  font-size: 13px;
  font-weight: 600;
  color: #fff;
  margin: 0;
  line-height: 1.3;
}

.unichat-team-toast__subtitle {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  margin: 0;
  line-height: 1.3;
}

.unichat-team-toast-fade-enter-active,
.unichat-team-toast-fade-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}

.unichat-team-toast-fade-enter-from,
.unichat-team-toast-fade-leave-to {
  opacity: 0;
  transform: translateY(8px);
}
</style>
